// import hooks
import { useState, useEffect } from "react";
import { MAC, WIN, LINUX } from "../../constants/platform.consts.js";
export const useGetPlatform = () => {
    const [_platform, setPlatform] = useState("");
    useEffect(() => {
        const agent = navigator.userAgent;
        if (/Mac/i.test(agent)) {
            setPlatform(MAC);
        }
        else if (/Win/i.test(agent)) {
            setPlatform(WIN);
        }
        else if (/Linux/i.test(agent)) {
            setPlatform(LINUX);
        }
    }, []);
    return _platform;
};
export default useGetPlatform;
